<div class="w-100 d-flex flex-column vehicle-storage-options-container mt-2">
    <div class="options-container">
        <div>
            <div class="form-box mt-2">
                <div class="input-container">
                    <label for="completeLocation">{{ 'vehicle_storage_select_location_description' |
                        translate
                        }}</label>
                    <div tabindex="0" class="autocompleteInput">
                        <img src="assets/icons/new-service-pickup-location.svg" alt="location" class="form-icon" />
                        <input placeholder="Carrer del Comte Borrell, 42, 08015, Barcelona, España"
                            #inputFieldAutocomplete1 name="completeLocation" />
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-start vehicle-storage-options-container w-100">
            <div [ngClass]="{
            checked: vehicleStorageLocationType === 1,
            'not-checked': vehicleStorageLocationType !== 1,
          }" (click)="selectVehicleStorageType(1)" (keydown)="selectVehicleStorageType(1)" tabindex="0"
                class="d-flex flex-row vehicle-storage-option w-100 hover-container">
                <div></div>
                <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-row w-100">
                        <div class="option-title">{{ 'interior' | translate }}</div>
                    </div>
                </div>
            </div>
            <div [ngClass]="{
            checked: vehicleStorageLocationType === 2,
            'not-checked': vehicleStorageLocationType !== 2,
          }" (click)="selectVehicleStorageType(2)" (keydown)="selectVehicleStorageType(2)" tabindex="0"
                class="d-flex flex-row vehicle-storage-option w-100 hover-container">
                <div></div>
                <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-row w-100">
                        <div class="option-title">
                            {{ 'openAir' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 vehicle-storage-list-panel">
            <div class="options-container">
                <div class="move-question"><span>{{ 'showing' | translate }}
                    </span><span>{{vehicle_storages.length}}
                    </span>
                    <span *ngIf="vehicleStorageLocationType === 1">{{'vehicleStorageInside' |
                        translate}}</span>
                    <span *ngIf="vehicleStorageLocationType === 2">{{'vehicleStorageOpenAir' |
                        translate}}</span>
                </div>
                <div *ngFor="let vehicle_storage of vehicle_storages" class="vehicle-storage-card w-100"
                    (click)="selectVehicleStorage(vehicle_storage)" (keydown)="selectVehicleStorage(vehicle_storage)">
                    <div [ngClass]="{
                checked: is_checked(vehicle_storage),
                'not-checked': !is_checked(vehicle_storage),
              }">
                        <div class="premium-label-box d-flex gap-1">
                            <div class="premium-label" *ngIf="vehicle_storage.IsCover">
                                {{ 'cover' | translate }}
                            </div>
                            <div class="premium-label" *ngIf="!vehicle_storage.IsCover">
                                {{ 'openAir' | translate }}
                            </div>
                            <div class="extrafee-label" *ngIf="showPrice && vehicle_storage.ExtraPrice">
                                {{ 'supplement' | translate }} +{{vehicle_storage.ExtraPrice}}€
                            </div>
                        </div>
                        <div class="d-flex flex-row gap-1 mt-2">
                            <div class="d-flex flex-column w-100 gap-2">
                                <div class="d-flex flex-row justify-content-between">
                                    <div class="vehicle-storage-name">
                                        {{ vehicle_storage.Name }}
                                    </div>
                                </div>
                                <div class="available-box">
                                    <img src="/assets/icons/badge-check.svg" alt="disponible" />
                                    <span>{{ 'available' | translate }}</span>
                                </div>
                                <div class="d-flex f-row gap-2 vehicle_storage_info">
                                    <img src="/assets/icons/location-icon.svg" alt="" />
                                    <span class="vehicle_storage_city">{{ vehicle_storage.City
                                        }}</span>&nbsp;-&nbsp;
                                    <span>{{ vehicle_storage.Address }}</span>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="showPrice" class="d-flex d-row align-items-center">
                            <div class="w-50"></div>
                            <div class="w-50">
                                <div class="price-checkin">
                                    {{ 'checkin' | translate }}: {{ vehicle_storage.InitialPrice }}€
                                </div>
                                <div class="price-per-day">
                                    {{ 'pricePerDay' | translate }}: {{ vehicle_storage.PerDayPrice }}€
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-between align-items-center">
                    <div class="pagination-info" *ngIf="vehicle_storages.length > 0">
                        {{ 'page' | translate }} <span>{{ page }}</span>
                        {{ 'of' | translate }}
                        <span>{{ pageCount }}</span>
                    </div>
                    <div class="pagination" *ngIf="vehicle_storages.length > 0">
                        <div class="button" (keydown)="prevPage()" (click)="prevPage()" tabindex="0">
                            <img src="/assets/icons/chevron-left.svg" class="img-rotate" alt="Arrow left" />
                        </div>
                        <ng-container *ngFor="let generatePage of pages">
                            <div *ngIf="generatePage === -1" class="button">...</div>
                            <div *ngIf="generatePage !== -1" class="button"
                                [ngClass]="{ 'button-selected': generatePage === page }" (click)="setPage(generatePage)"
                                (keydown)="setPage(generatePage)" tabindex="0">
                                {{ generatePage }}
                            </div>
                        </ng-container>
                        <div class="button" (keydown)="nextPage()" (click)="nextPage()" tabindex="0">
                            <img src="/assets/icons/chevron-left.svg" alt="Arrow right" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>